import React, {
  useMemo, useState
} from 'react';
import { Form } from 'components/atoms';
import { Formik, Field } from 'formik';
import {
  FieldCustom,
  FieldMarkdown
} from 'components/molecules';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useDebounce } from 'react-use'

import { linkVideoRegex } from 'services/constants'

const Schema = Yup.object().shape({
  title: Yup.string()
    .min(1, 'Mínimo de 1 carácter')
    .max(120, 'Máximo de 120 caracteres')
    .nullable()
    .notRequired(),
  description:
    Yup.string()
      .max(500, 'Máximo de 500 caracteres')
      .notRequired()
      .nullable(),
  url: Yup.string()
    .matches(linkVideoRegex, 'O URL inserido não é válido. \n Certifique-se que está no seguinte formato: \nyoutube(http://www.youtube.com/watch/....)\n videocast(https://videocast.fccn.pt/embed/v/..../iframe) ou (https://videocast.fccn.pt/live/..../....)\nvimeo(https://vimeo.com/....)')
    .required('Campo obrigatório')
});


const SubWebVideoEditor = ({ initialProps, onChange }) => {
  const [editorProps, setEditorProps] = useState(initialProps)
  const initialValues = useMemo(() => {
    const {
      title, 
      url, 
      description,
      disableCookiesCheck
    } = initialProps;

    return {
      title, 
      url, 
      description,
      disableCookiesCheck: disableCookiesCheck ?? true 
    };
  }, [initialProps]);


  const handleFormChange = newValues => {
    const {
      title, url, description, ...values
    } = newValues


    const newProps = {
      ...initialProps,
      ...values,
      title,
      url,
      description
    }

    const isValid = Schema.isValidSync(newProps)
    if (isValid) setEditorProps(newProps)
  };

  useDebounce(() => {
    onChange(editorProps);
  }, 200,
  [editorProps]
  )
  return (

    <Formik
      initialValues={initialValues}
      validationSchema={Schema}
      validate={handleFormChange}
      enableReinitialize
    >
      <Form>
        <Field
          title="Título"
          name="title"
          info="Título do video ou secção"
          component={FieldCustom}
          maxLetters={120}
        />
        <Field
          title="Video"
          name="url"
          info="Url do video. Suporta as plataformas: youtube, vimeo e videocast"
          component={FieldCustom}
          type="url"
        />
        <Field
          title="Descrição"
          name="description"
          component={FieldMarkdown}
          maxLetters={500}
        />
      </Form>
    </Formik>
  );
};

SubWebVideoEditor.propTypes = {
  onChange: PropTypes.func.isRequired,
  initialProps: PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string,
    title: PropTypes.string,
  }),
};

SubWebVideoEditor.defaultProps = {
  initialProps: {}
};

export default SubWebVideoEditor;
